import { AfterContentInit, Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";
import { HeroService } from "../../services/hero.service";

@Component({
    selector: "app-page-not-found",
    templateUrl: "./page-not-found.component.html",
    styleUrls: ["./page-not-found.component.scss"]
})
export class PageNotFoundComponent implements OnInit, AfterContentInit {
    @ViewChild("hero", { static: true }) hero: ElementRef;

    constructor(public heroService: HeroService, private analyticsHelper: AnalyticsHelperService) {}

    ngOnInit() {
        this.getContentHeight();

        this.analyticsHelper.trackPageLoad("page-not-found");
    }

    ngAfterContentInit() {
        this.heroService.setHero(this.hero);
    }

    @HostListener("window:resize", ["$event"])
    onWindowResize() {
        this.getContentHeight();
    }

    private getContentHeight() {
        const footerHeight = document.querySelector(".footer")?.scrollHeight || 0;
        const windowHeight = window.innerHeight;
        const newContentHeight = windowHeight - footerHeight;
        const newVhHeight = (newContentHeight / windowHeight) * 100;

        // Set page min height
        document.getElementById("page-404")!.style.minHeight = newVhHeight + "vh";
    }
}
